import React, {
  useCallback,
  useState,
} from 'react';
import {
  Select,
  Spin,
} from 'antd';
import {
  arrayOf,
  number,
  shape,
  string,
} from 'prop-types';
import axios from 'axios';
import { switch_company_memberships_path } from 'js-routes/generated/routes';

const CompanySelector = ({ item }) => {
  const { memberships, currentCompanyId } = item;
  const [spinning, setSpinning] = useState(false);

  const changeCompany = useCallback((companyId) => {
    setSpinning(true);
    axios.post(switch_company_memberships_path({ format: 'json' }), { companyId })
      .then(() => {
        globalThis.location.href = '/';
      });
  }, []);

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <Select
        showSearch
        optionFilterProp="label"
        defaultValue={currentCompanyId}
        getPopupContainer={() => document.body}
        options={memberships}
        onChange={changeCompany}
      />
    </>
  );
};

CompanySelector.propTypes = {
  item: shape({
    memberships: arrayOf(shape({
      key: string.isRequired,
      label: string.isRequired,
      value: number.isRequired,
    })).isRequired,
    currentCompanyId: number.isRequired,
  }).isRequired,
};

export default CompanySelector;
